module.exports = __webpack_public_path__ + "img/melissa-calendario2.627c2a9a.png";